import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { IPreConsentPlanDto } from '@classictechsolutions/hubapi-transpiled-enums';
import {ToastService} from '@app/core/services/toast/toast.service';
import {CbDialogService} from '@app/shared/components/dialog/cb-dialog.service';
import {IPreConsentPlanMappedItem} from '@app/logic/pre-consent-plans';
import {IPreConsentPlansLogicService} from '@app/logic/pre-consent-plans/interfaces/i.pre-consent-plans-logic.service';
import { DesignComplexityLogicService } from '@app/logic/design-complexity';
import { DesignComplexityDialogFormViewBase } from '../../shared/design-complexity-dialog-form-view.base';

@Component({
    selector: 'cb-finalise-preconsent-plan-dialog',
    templateUrl: './finalise-preconsent-plan-dialog.component.html',
    styleUrls: ['./finalise-preconsent-plan-dialog.component.scss'],
    standalone: false
})
export class FinalisePreconsentPlanDialogComponent extends DesignComplexityDialogFormViewBase<IPreConsentPlanDto, IPreConsentPlanMappedItem, IPreConsentPlansLogicService>  {
    public static readonly MIN_WIDTH = '33%';
    public finaliseInProgress: boolean;
    public jobNumber: string;
    public mappedItem: IPreConsentPlanMappedItem;

    constructor(
        public readonly dialogRef: MatDialogRef<FinalisePreconsentPlanDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: {
            mappedItem: IPreConsentPlanMappedItem;
            jobNumber: string;
        },
        public toastService: ToastService,
        designComplexityLogicService: DesignComplexityLogicService,
        public readonly cbDialog: CbDialogService,
    ) {
        super(dialogRef, toastService, designComplexityLogicService);
        this.finaliseInProgress = false;
        this.jobNumber = this.data.jobNumber;
        this.mappedItem = this.data.mappedItem;
        this.loadDesignComplexities(this.mappedItem.designComplexity?.id ?? 0);
    }

    public updatedDesignComplexity(selectedId: number): void {
        this.loadDesignComplexities(selectedId ?? 0);
    }

    public finalisePreConsentPlan(): void {
        this.finaliseInProgress = true;
        this.cbDialog.confirm({
            dialogHeading: 'Finalise Pre-Consent',
            message: 'Are you sure you want to finalise this Pre-Consent?',
            confirmed: () => {
                this.finaliseInProgress = false;
                this.dialogRef.close(this.mappedItem);
            },
            declined: () => {
                this.finaliseInProgress = false;
            }
        });
    }

    public cancel(): void {
        this.dialogRef.close(false);
    }
}
